import "./Nav.css";
const Nav = ({ active, setActive }) => {
 return (
  <div className="settings-nav">
   <div
    className={
     active === "personalinformation" || active === "editpersonalinformation"
      ? "item active"
      : "item"
    }
    onClick={() => setActive("personalinformation")}
   >
    Personal Information
   </div>
   <div
    className={active === "security" ? "item active" : "item"}
    onClick={() => setActive("security")}
   >
    Security
   </div>
   <div
    className={
     active === "payouts" || active === "addpayouts" ? "item active" : "item"
    }
    onClick={() => setActive("payouts")}
   >
    Payout
   </div>
   <div
    className={active === "notification" ? "item active" : "item"}
    onClick={() => setActive("notification")}
   >
    Notifications
   </div>
   <div
    className={active === "globalpreference" ? "item active" : "item"}
    onClick={() => setActive("globalpreference")}
   >
    Global Preference
   </div>
  </div>
 );
};

export default Nav;
